import { reporter } from "apps/commons/functions/reporter";
import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import { useEffect } from "react";
import { useParams } from "router";

export const useNavigationLogging = () => {
    const { pathname } = useDynamicLocation();
    const { propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId");

    useEffect(() => {
        reporter.info(`Property ${propertyId} landed at page ${pathname}`);
    }, [pathname, propertyId]);
};
